import * as defaultRules from '../rules'

import createTokenizer from './createTokenizer'

const rules = [defaultRules.Word, defaultRules.WhiteSpace, defaultRules.NewLine]

let tokenize = createTokenizer(rules)

export default function (value) {
  return tokenize(value)
}

export const registerTextRule = (rule) => {
  rules.push(rule)
  tokenize = createTokenizer(rules)
}
